import { getDatabase, ref } from 'firebase/database';
import { initializeApp, getApp } from 'firebase/app';
import { DB_PATH } from '../constants';

const firebaseConfig = {
  apiKey: "AIzaSyA5CpL8f4-17p5wyhOuuRLX2SxhZEJlTDM",
  authDomain: "ietsene-aab27.firebaseapp.com",
  databaseURL: "https://ietsene-aab27-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "ietsene-aab27",
  storageBucket: "ietsene-aab27.appspot.com",
  messagingSenderId: "925797394423",
  appId: "1:925797394423:web:ff0fd72175783fbb3eb0f2",
  measurementId: "G-3RQN7Q17MX",
};

function getFirebaseApp() {
  try {
    return getApp();
  } catch {
    return initializeApp(firebaseConfig);
  }
}

const getDb = () => getDatabase(getFirebaseApp());
export const getProductsRef = () => ref(getDb(), DB_PATH);
